import { useState } from 'react';

import { MultiTierCheckoutSession } from '../../types';

/**
 * Manages the value of the special code entered by the user.
 * A special code can be a private tier unlock code or a discount code.
 * This hook is only handling the code itself (ie: value of the special code field in the UI / code passed by the URL).
 * Discount data and private tier unlocks are handled in their respective hooks.
 */
const useSpecialCode = () => {
  const [code, setCode] = useState(null);
  const [discountCode, setDiscountCode] = useState(null);

  /**
   * Applies a discount code
   */
  const applyDiscountCode = (
    code: string,
    checkoutUpdater?: (code: string) => Promise<MultiTierCheckoutSession>
  ) => {
    if (checkoutUpdater) {
      checkoutUpdater(code).then(() => setDiscountCode(code));
    } else {
      setDiscountCode(code);
    }
  };

  return {
    discountCode: { value: discountCode, applyDiscountCode },
    code: { value: code, setCode }
  };
};

export default useSpecialCode;
